export default __webpack_public_path__ + "static/media/quality-bad.ef80b1da.svg";